<template>
  <GeneralDialog v-model:visible="visible" @dismiss="onClose">
    <div class="w-full p-3.75">
      <div class="mb-7.5">
        <div :class="$typo.openSansBold16" class="leading-3 text-text-muted mb-4">
          {{ t('adConsentModalHeader') }}
        </div>
      </div>
      <div>
        <p>{{ t('adConsentModalBodyText') }}</p>
        <p>{{ t({ key: 'adConsentModalAmountOfTokens', context: { count: adSkipTokens } }) }}</p>
      </div>
      <div class="grid grid-cols-2 mt-4 gap-4">
        <Button @click="onShortAdClick" :disabled="isAdLoading" class="relative">
          {{ t({ key: 'adConsentModalCtaShowShortAd', context: { count: config.shortAdReward } }) }}
          <Spinner v-if="isAdLoading" :size="16" class="absolute right-2" />
        </Button>
        <Button @click="onLongAdClick" :disabled="isAdLoading" class="relative">
          {{ t({ key: 'adConsentModalCtaShowLongAd', context: { count: config.longAdReward } }) }}
          <Spinner v-if="isAdLoading" :size="16" class="absolute right-2" />
        </Button>
        <Button @click="onSkipClick" :disabled="isAdLoading || adSkipTokens < config.adSkipCost">
          {{ t({ key: 'adConsentModalCtaSkipAd', context: { count: config.adSkipCost } }) }}
        </Button>
        <Button @click="onBuyAbo" :disabled="isAdLoading">
          {{ t('adConsentModalCtaBuyAdFree') }}
        </Button>
      </div>
    </div>
  </GeneralDialog>
</template>

<script setup lang="ts" generic="T">
import { useLocalizationStore } from '@/stores/localization.ts'
import $typo from '@/styles/typografy.module.css'
import GeneralDialog from '@/components/GeneralDialog.vue'
import Button from '@/components/Button.vue'
import Spinner from '@/components/Spinner.vue'
import { useAdmobStore } from '@/stores/admob.ts'
import { storeToRefs } from 'pinia'
import { useUiStore } from '@/stores/ui.store.ts'

const { showRewardedAd, showRewardedInterstitial, useAdSkipTokens, setCurrentAdScore } =
  useAdmobStore()
const { isAdLoading, config, adSkipTokens } = storeToRefs(useAdmobStore())
const { openSubscribeToPlan } = useUiStore()

const visible = defineModel('visible', { default: false })

const { t } = useLocalizationStore()

function close() {
  visible.value = false
}

function onClose() {
  setCurrentAdScore(0)
}

function onBuyAbo() {
  openSubscribeToPlan()
}

async function onSkipClick() {
  if (await useAdSkipTokens()) {
    close()
    return
  }
}

async function onShortAdClick() {
  await showRewardedInterstitial()
  close()
}

async function onLongAdClick() {
  await showRewardedAd()
  close()
}
</script>
